import {useQuery} from "react-query";
import {deviceVersion} from "../../../../API/TT_ELD/Team/deviceVersion";

export const useDevicesVersion = (): object => {
    return useQuery([
            `devices/`, ], () => deviceVersion.read(),
        { refetchOnWindowFocus: false })
}
